module.exports = __webpack_public_path__ + "static/media/psd.94a4fb5f.svg";